import { IProductDetails, IStockProductSearchResult } from '../types'
import webApi from './webApi'
import { ApiClient } from './ApiClient'
import logger from '../logging/logger'

/* DPAS API */
const GetProduct = async (
  apiClient: ApiClient,
  barcode: string,
  locationId: string
): Promise<IProductDetails[] | any> => {
  const response = await webApi.get<IProductDetails[]>(apiClient, {
    url: `/api/product`,
    params: { barcode: barcode, locationId: locationId }
  })
  return response
}

/* Stock Platform API */
const SearchProduct = async (
  apiClient: ApiClient,
  query: string,
  locationId: string,
  page: number = 1
): Promise<IStockProductSearchResult> => {
  try {
    const response = await webApi.get<IStockProductSearchResult>(apiClient, {
      url: `/api/stock/${encodeURIComponent(locationId)}/search/${encodeURIComponent(query)}`,
      params: { page }
    })

    // Validate response structure to prevent crashes from unexpected data
    if (!response || typeof response !== 'object') {
      logger.warning('[SearchProduct] Invalid response structure received')
      return {
        products: [],
        totalResults: 0,
        totalPages: 0,
        currentPage: page,
        pageSize: 0
      }
    }

    // Ensure products array exists and is valid
    const safeResponse: IStockProductSearchResult = {
      products: Array.isArray(response.products) 
        ? response.products.map(product => ({
            ...product,
            price: product.price ? (parseFloat(product.price) / 100).toFixed(2) : product.price
          }))
        : [],
      totalResults: response.totalResults ?? 0,
      totalPages: response.totalPages ?? 0,
      currentPage: response.currentPage ?? page,
      pageSize: response.pageSize ?? 0,
      query: response.query,
      storeCode: response.storeCode
    }

    logger.info('[SearchProduct] Search completed', {
      totalResults: safeResponse.totalResults,
      totalPages: safeResponse.totalPages,
      currentPage: safeResponse.currentPage
    })

    return safeResponse
  } catch (error: any) {
    logger.error('[SearchProduct] API call failed', {
      errorMessage: error?.message || 'Unknown error',
      page: page
    })
    
    return {
      products: [],
      totalResults: 0,
      totalPages: 0,
      currentPage: page,
      pageSize: 0
    }
  }
}

const productApi = {
  GetProduct,
  SearchProduct
}

export default productApi